import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import {
  getJobExperiences,
  getTotalVacancies,
  toArray,
  getJobResponsibility,
} from "../../../helpers/common";
import { Icon } from "@iconify/react";

const JobDetailsDescription = ({ details }) => {
  const getList = (list) => {
    let listArr = toArray(list, "\n");

    return listArr.map((h, index) => (
      <li
        key={"list-" + index}
        className="d-flex align-items-center gap-2 mb-1"
      >
        <i className="uil uil-check-circle text-success"></i>
        <span>{h}</span>
      </li>
    ));
  };

  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [shareCopied, setShareCopied] = useState(false);

  const shareUrl = window.location.href;
  const shareText = `Check out this job opening: ${details?.jobTitle || ""}`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setShareCopied(true);
      setTimeout(() => setShareCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy job link:", err);
    }
  };

  const handleWhatsAppShare = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      `${shareText} ${shareUrl}`,
    )}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  // 🎯 FIX: was opening the WhatsApp URL instead of Instagram — Instagram
  // has no direct web share link, so this copies the message and opens
  // Instagram's site so the user can paste it themselves.
  const handleInstaShare = async () => {
    try {
      await navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
    } catch (err) {
      console.error("Failed to copy share message:", err);
    }
    window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
  };

  // 🎯 FIX: was opening the WhatsApp URL instead of Facebook's own share link
  const handleIFacebookShare = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      shareUrl,
    )}&quote=${encodeURIComponent(shareText)}`;
    window.open(facebookUrl, "_blank", "noopener,noreferrer");
  };

  // 🎯 NEW: same additional platforms as SingleJobItem's share modal







  const getKeywords = (list) => {
    let listArr = toArray(list, ",");
    return listArr.map((h, index) => (
      <span
        className="text-light text-uppercase badge bg-primary text-wrap lh-sm text-break"
        key={"keywords-" + index}
      >
        {h}
      </span>
    ));
  };

  return (
    <React.Fragment>
      <Card
        className="job-detail overflow-hidden"
        style={{ position: "relative" }}
      >
        {/* Share Button */}
        <button
          type="button"
          onClick={() => setShareModalOpen(true)}
          title="Share this job"
          className="btn btn-primary shadow-sm d-flex align-items-center gap-1"
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            zIndex: 10,
            fontSize: "14px",
          }}
        >
          <Icon icon="mdi:share-variant-outline" fontSize={18} />
          <span className="d-none d-sm-inline">Share</span>
        </button>

        <CardBody className="p-4">
          <div>
            <Row>
              <Col md={8}>
                <h4 className="mb-1">{details.jobTitle}</h4>
                <ul className="list-inline text-muted mb-0">
                  <li className="list-inline-item">
                    <i className="mdi mdi-account"></i>{" "}
                    {getTotalVacancies(details)}
                  </li>
                </ul>
              </Col>
              {/* <Col lg={4}>
                <ul className="list-inline mb-0 text-lg-end mt-3 mt-lg-0">
                  <li className="list-inline-item">
                    <div className="favorite-icon">
                      <Link to="#">
                        <i className="uil uil-heart-alt"></i>
                      </Link>
                    </div>
                  </li>
                  <li className="list-inline-item">
                    <div className="favorite-icon">
                      <Link to="#">
                        <i className="uil uil-setting"></i>
                      </Link>
                    </div>
                  </li>
                </ul>
              </Col> */}
            </Row>
          </div>

          <div className="mt-4">
            <Row className="g-3 mt-1">
              <Col lg={3} md={6}>
                <div className="border rounded p-2 shadow-sm h-100">
                  <div className="d-flex align-items-center mb-2">
                    <div
                      className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: "42px", height: "42px" }}
                    >
                      <i
                        className="uil uil-briefcase-alt text-primary"
                        style={{ fontSize: "20px" }}
                      ></i>
                    </div>
                    <p className="text-muted mb-0 fs-13">Experience</p>
                  </div>

                  <h6 className="fw-semibold mb-0">
                    {getJobExperiences(details)}
                  </h6>
                </div>
              </Col>

              <Col lg={3} md={6}>
                <div className="border rounded p-2 shadow-sm h-100">
                  <div className="d-flex align-items-center mb-2">
                    <div
                      className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: "42px", height: "42px" }}
                    >
                      <i
                        className="uil uil-user-square text-success"
                        style={{ fontSize: "20px" }}
                      ></i>
                    </div>
                    <p className="text-muted mb-0 fs-13">Position</p>
                  </div>

                  <h6 className="fw-semibold mb-0">
                    {details?.jobTitle || "Not available"}
                  </h6>
                </div>
              </Col>

              <Col lg={3} md={6}>
                <div className="border rounded p-2 shadow-sm h-100">
                  <div className="d-flex align-items-center mb-2">
                    <div
                      className="bg-danger bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: "42px", height: "42px" }}
                    >
                      <i
                        className="uil uil-map-marker text-danger"
                        style={{ fontSize: "20px" }}
                      ></i>
                    </div>
                    <p className="text-muted mb-0 fs-13">Location</p>
                  </div>

                  <h6 className="fw-semibold mb-0">
                    {details.location.state || "Not Available"}
                  </h6>
                </div>
              </Col>

              <Col lg={3} md={6}>
                <div className="border rounded p-2 shadow-sm h-100">
                  <div className="d-flex align-items-center mb-2">
                    <div
                      className="bg-warning bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2"
                      style={{ width: "42px", height: "42px" }}
                    >
                      <i
                        className="uil uil-money-bill text-warning"
                        style={{ fontSize: "20px" }}
                      ></i>
                    </div>
                    <p className="text-muted mb-0 fs-13">Offer Salary</p>
                  </div>

                  <h6 className="fw-semibold mb-0">
                    ₹{details.maximumSalaryPerMonth}/ Month
                  </h6>
                </div>
              </Col>
            </Row>
          </div>
          <div className="row g-4 mt-2">
            {/* Qualification */}
            {details?.qualificationsRequired && (
              <div className="col-lg-6">
                <div className="card border rounded p-2 shadow-sm h-100">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-success bg-opacity-10 rounded-circle p-2 me-3">
                        <Icon
                          icon="mdi:school-outline"
                          className="text-success"
                          fontSize={24}
                        />
                      </div>

                      <div>
                        <h5 className="mb-0 fw-bold">Qualification</h5>
                        <small className="text-muted">
                          Required educational qualifications
                        </small>
                      </div>
                    </div>

                    <ul className="list-group list-group-flush">
                      {getList(details.qualificationsRequired)}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* Skills */}
            {details?.skillsAndExperience && (
              <div className="col-lg-6">
                <div className="card border rounded p-2 shadow-sm h-100">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-3">
                      <div className="bg-warning bg-opacity-10 rounded-circle p-2 me-3">
                        <Icon
                          icon="mdi:briefcase-account-outline"
                          className="text-warning"
                          fontSize={24}
                        />
                      </div>

                      <div>
                        <h5 className="mb-0 fw-bold">Skills & Experience</h5>
                        <small className="text-muted">
                          Required technical and professional skills
                        </small>
                      </div>
                    </div>

                    <ul className="list-group list-group-flush">
                      {getList(details.skillsAndExperience)}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Keywords */}
          {details?.searchKeywords && (
            <div className="card border-0 shadow-sm mt-4">
              <div className="card-body">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                    <Icon
                      icon="mdi:tag-multiple-outline"
                      className="text-primary"
                      fontSize={24}
                    />
                  </div>

                  <div>
                    <h5 className="mb-0 fw-bold">Search Keywords</h5>
                    <small className="text-muted">
                      Relevant technologies & keywords
                    </small>
                  </div>
                </div>

                <div className="d-flex flex-wrap gap-2">
                  {getKeywords(details.searchKeywords)}
                </div>
              </div>
            </div>
          )}

          {details?.description ? (
            <div className="mt-4">
              <h5 className="mb-3">Job Description</h5>
              <div className="job-detail-desc">
                <p className="text-muted mb-0">{details?.description}</p>
              </div>
            </div>
          ) : null}

          {getJobResponsibility(details) && (
            <div className="mt-4">
              <h5 className="mb-3 d-flex align-items-center">
                <Icon
                  icon="mdi:clipboard-check-outline"
                  className="me-2 text-primary"
                  fontSize={22}
                />
                Key Job Responsibilities
              </h5>
              <div
                className="job-detail-desc mt-2"
                dangerouslySetInnerHTML={{
                  __html: getJobResponsibility(details),
                }}
              />
            </div>
          )}

          {/* <div className="mt-4 pt-3">
            <ul className="list-inline mb-0">
              <li className="list-inline-item mt-1">Share this job:</li>
              <li className="list-inline-item mt-1">
                <Link to="#" className="btn btn-primary btn-hover">
                  <i className="uil uil-facebook-f"></i> Facebook
                </Link>
              </li>
              <li className="list-inline-item mt-1">
                <Link to="#" className="btn btn-danger btn-hover">
                  <i className="uil uil-google"></i> Google+
                </Link>
              </li>
              <li className="list-inline-item mt-1">
                <Link to="#" className="btn btn-success btn-hover">
                  <i className="uil uil-linkedin-alt"></i> linkedin
                </Link>
              </li>
            </ul>
          </div> */}
        </CardBody>
      </Card>

      {/* Share Modal */}
      <Modal
        isOpen={shareModalOpen}
        toggle={() => setShareModalOpen(false)}
        centered
        className="share-job-modal"
      >
        <ModalHeader toggle={() => setShareModalOpen(false)}>
          Share this Job
        </ModalHeader>
        <ModalBody className="p-3 p-sm-4">
          <div className="d-flex flex-wrap justify-content-center gap-3 gap-sm-4 mb-3">
            <div
              className="text-center"
              role="button"
              onClick={handleWhatsAppShare}
              style={{ cursor: "pointer" }}
            >
              <div
                className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-1"
                style={{ width: "52px", height: "52px", background: "#25D366" }}
              >
                <Icon icon="mdi:whatsapp" fontSize={28} color="#fff" />
              </div>
              <small className="text-muted">WhatsApp</small>
            </div>
            <div
              className="text-center"
              role="button"
              onClick={handleInstaShare}
              style={{ cursor: "pointer" }}
            >
              <div
                className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-1"
                style={{ width: "52px", height: "52px", background: "#E1306C" }}
              >
                <Icon icon="mdi:instagram" fontSize={28} color="#fff" />
              </div>
              <small className="text-muted">Instagram</small>
            </div>
            <div
              className="text-center"
              role="button"
              onClick={handleIFacebookShare}
              style={{ cursor: "pointer" }}
            >
              <div
                className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-1"
                style={{ width: "52px", height: "52px", background: "#387ed8" }}
              >
                <Icon icon="mdi:facebook" fontSize={28} color="#fff" />
              </div>
              <small className="text-muted">Facebook</small>
            </div>









          </div>


          <div className="input-group">
            <input
              type="text"
              readOnly
              className="form-control"
              value={shareUrl}
              onClick={(e) => e.target.select()}
            />
            <button
              className="btn btn-primary"
              type="button"
              onClick={handleCopyLink}
            >
              {shareCopied ? "Copied!" : "Copy"}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default JobDetailsDescription;